import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "app/lib/store/store";
import { useNavigate } from "react-router-dom";
import { useEmployment } from "app/hooks/employment/useEmployment";
import { EMPLOYMENT } from "app/constants/apiEndPoints";
import {
  setStep,
  addStepsData,
} from "app/lib/store/slices/steps/employmentDetails";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import { employmentDetailsFromOne } from "app/utils/types";
import DynamicFormOne from "./dynamicForms/DynamicFormOne";
import { handleApiError } from "app/utils/handleApiError";

const PartOne: React.FC = () => {
  const dispatch = useDispatch();
  const savedIds = useSelector(
    (state: RootState) => state.loanTypesSteps.savedIds
  );
  const navigate = useNavigate();
  const { mutate: submitEmployment, isPending } = useEmployment();
  const { formOne, ...others } = useSelector(
    (state: RootState) => state.employmentDetails.stepsData
  );
  const { applicants } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    register,
    setValue,
    setError,
    clearErrors,
    watch,
  } = useForm<employmentDetailsFromOne>({
    defaultValues: {
      currentEmployment: "",
      currentOccupation: "",
      employerName: "",
      abn: "",
      employerAddress: {
        street: "",
        state: "",
        postCode: "",
      },
      employerPhoneNumber: "",
    },
  });
  const currentEmployment = watch("currentEmployment");

  const onSubmit = (data: employmentDetailsFromOne) => {
    submitEmployment(
      {
        url: `${EMPLOYMENT}/${savedIds?.employmentID}/first`,
        data: data,
      },
      {
        onSuccess: (res: any) => {
          dispatch(
            addStepsData({
              ...others,
              formOne: data,
            })
          );
          dispatch(setStep(2));
        },
        onError: (error: any) => {
          handleApiError(error);
        },
      }
    );
  };
  useEffect(() => {
    if (formOne) {
      reset(formOne);
    } else {
      const { employment } = applicants || {};

      const { employerName, employmentType } = employment || {};

      if (employerName) {
        setValue("employerName", employerName);
      }
      if (employmentType) {
        setValue("currentEmployment", employmentType);
      }
    }
  }, [formOne, reset]);

  const handlePrevious = () => {
    navigate(`/personal-details`);
  };

  useEffect(() => {
    if (
      currentEmployment === "unemployed_or_retired" ||
      currentEmployment === "contractor" ||
      currentEmployment === "self-employed"
    ) {
      clearErrors("currentOccupation");
      clearErrors("employerName");
      clearErrors("employerPhoneNumber");
      clearErrors("employerAddress.postCode");
      clearErrors("employerAddress.state");
      clearErrors("employerAddress.street");
    }
  }, [currentEmployment]);

  return (
    <>
      <ProgressBar progress={0} MB={7} />
      <div className="w-full  sm:w-[70%] xl:w-[40%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Employment Details" />

        <form onSubmit={handleSubmit(onSubmit)} className="mt-6">
          <DynamicFormOne
            control={control}
            errors={errors}
            register={register}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            currentEmployment="currentEmployment"
            currentOccupation="currentOccupation"
            employerName="employerName"
            employerPhoneNumber="employerPhoneNumber"
            addressStreetName="employerAddress.street"
            addressStateName="employerAddress.state"
            addressPostCodeName="employerAddress.postCode"
            abn="abn"
            currentEmploymentType={currentEmployment}
          />

          <div className="flex justify-between my-10">
            <PreviousButtom onClick={handlePrevious}>Previous</PreviousButtom>
            <ContinueButton type="submit" loading={isPending}>
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PartOne;
